import React from 'react';
import { Box, Typography, useTheme } from '@mui/material';
import { getBaseStyle } from '../../../edit/media/utils/baseStyles';
import { useDropzone } from 'react-dropzone';
import { useMediaQuery } from '@mui/system';
import AddIcon from '@mui/icons-material/AddCircleOutlineOutlined';

interface DropZoneProps {
  setFile: React.Dispatch<React.SetStateAction<File | null>>;
  acceptedTypes: { [key: string]: string[] };
}

const DropZone: React.FC<DropZoneProps> = ({ setFile, acceptedTypes }) => {
  const theme = useTheme();
  const isSmallDisplay = useMediaQuery(theme.breakpoints.down('md'));
  const baseStyle = getBaseStyle(theme);

  const handleDrop = async (files: File[]) => {
    try {
      setFile(files[0]);
    } catch (error) {
      console.error(error);
    }
  };

  const { getRootProps, getInputProps } = useDropzone({
    accept: acceptedTypes,
    minSize: 0,
    onDrop: (files) => {
      handleDrop(files);
    },
  });

  return (
    <section className="container" style={{ maxWidth: '500px' }}>
      <Box
        sx={{
          ...baseStyle,
          backgroundColor: 'background.secondary',
          padding: 2,
          height: isSmallDisplay ? '180px' : baseStyle.height,
          flexDirection: 'row',
        }}
        {...getRootProps({ className: 'dropzone' })}
      >
        <input {...getInputProps()} />
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'row',
            width: '100%',
            justifyContent: 'center',
            alignItems: 'center',
          }}
        >
          <Box sx={{ display: 'flex' }}>
            <Box
              sx={{
                display: isSmallDisplay ? 'none' : 'flex',
                flexDirection: 'row',
                alignItems: 'center',
                pr: 2,
              }}
            >
              <AddIcon fontSize="large" />
            </Box>
            <Box
              sx={{
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'center',
              }}
            >
              <Box
                sx={{
                  display: 'flex',
                  pl: '2px',
                  fontWeight: 'bold',
                  fontSize: '20px',
                  whiteSpace: 'pre',
                }}
              >
                {!isSmallDisplay && 'Drag and drop or '}
                <Typography
                  sx={{
                    display: 'flex',
                    pl: '2px',
                    fontWeight: 'bold',
                    fontSize: '20px',
                    color: 'secondary.medium',
                    textDecoration: 'underline',
                  }}
                >
                  {isSmallDisplay ? 'Click' : 'click'} to browse
                </Typography>
              </Box>
            </Box>
          </Box>
        </Box>
      </Box>
      <Box
        sx={{
          mt: 1,
          display: 'flex',
          flexDirection: { xs: 'column', sm: 'row' },
          justifyContent: 'space-between',
        }}
      >
        <Typography
          sx={{
            fontSize: '.8rem',
            color: 'grey.400',
          }}
        >
          Supported formats:{' '}
          {Object.values(acceptedTypes).map((types) =>
            types.map((type) => `${type.toUpperCase()} `),
          )}
        </Typography>
      </Box>
    </section>
  );
};

export default React.memo(DropZone);
